var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 289.1",
    style: {
      enableBackground: "new 0 0 283.5 289.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#54575D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st0",
    d: "M85,289.1c-7.2,0-13.3-2.5-18.4-7.6c-5-5-7.6-11.2-7.6-18.4c0-7.2,2.5-13.3,7.6-18.4 c5-5,11.2-7.6,18.4-7.6c7,0,13,2.5,18.2,7.6c5.2,5,7.7,11.2,7.7,18.4c0,7.2-2.5,13.3-7.6,18.4C98.4,286.6,92.2,289.1,85,289.1z  M229.2,289.1c-7.2,0-13.3-2.5-18.4-7.6c-5-5-7.6-11.2-7.6-18.4c0-7.2,2.5-13.3,7.6-18.4c5-5,11.2-7.6,18.4-7.6c7,0,13,2.5,18.2,7.6 c5.2,5,7.7,11.2,7.7,18.4c0,7.2-2.5,13.3-7.6,18.4C242.5,286.6,236.4,289.1,229.2,289.1z M66.3,51.3l39.6,82.2h103.8l0,0l0,0 l45-82.2l0,0l0,0H66.3z M55.5,29.7h212.2c7.7,0,12.6,2.3,14.6,7c2,4.7,1.4,9.9-2,15.7l-48.6,87.6c-2.4,4.1-5.8,7.6-10.1,10.6 c-4.3,3-9,4.5-14.1,4.5H98.4l-20.2,37.5c0,0,0,0,0,0c0,0,0,0,0,0h176.9v21.6H81.4c-10.1,0-17.4-3.4-21.8-10.1 c-4.4-6.7-4.4-14.3,0.2-22.7l23.1-42.5l-54.8-116H0V1.2h42.2L55.5,29.7z M105.9,133.4h103.8l0,0l0,0H105.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a184c5d0082eeca01d65f83b72cacadb.svg";
export { ForwardRef as ReactComponent };